import { ASSESSMENT_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/assessmentOverview/questionnaireAnswer'
import { CERT_PERIOD_RECAP_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/certPeriodRecap/questionnaireAnswer'
import { AUTHORIZATION_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/authorization/questionnaireAnswer'
import { VISIT_SCHEDULING_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/visitScheduling/questionnaireAnswer'
import { MEDICAL_BACKGROUND_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/medicalBackground/questionnaireAnswer'
import { MEDICATIONS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/medications/questionnaireAnswer'
import { DISCHARGE_PLANNING_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/dischargePlanning/questionnaireAnswer'
import { ADL_NEEDS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/adlNeeds/questionnaireAnswer'
import { PLAN_OF_CARE_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/planOfCare/questionnaireAnswer'
import { SUPERVISORY_REVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/supervisoryReview/questionnaireAnswer'
import { VITALS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/vitals/questionnaireAnswer'
import { NARRATIVE_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/narrative/questionnaireAnswer'
import { FINAL_STEPS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/finalSteps/questionnaireAnswer'
import { SKILLED_NEEDS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/skilledNeeds/questionnaireAnswer'

// Move to the sections folders
export const RECERT_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  // Assessment overview
  ...ASSESSMENT_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,

  // Cert Period Recap
  ...CERT_PERIOD_RECAP_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,

  // Authorizations
  ...AUTHORIZATION_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,

  // Visit scheduling
  ...VISIT_SCHEDULING_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,

  // Medical background
  ...MEDICAL_BACKGROUND_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,

  // Medications
  ...MEDICATIONS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  // Skilled Needs
  ...SKILLED_NEEDS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,

  ...ADL_NEEDS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,

  // Discharge Planning
  ...DISCHARGE_PLANNING_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,

  // Plan of Care
  ...PLAN_OF_CARE_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...SUPERVISORY_REVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,

  // Vitals
  ...VITALS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,

  // Narrative background
  ...NARRATIVE_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,

  // Final Steps
  ...FINAL_STEPS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE
}
